import React, { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ThemeContext from '../../contexts/theme.context';
import { BasicStatsItem } from './index.styles';
import { Text } from '../text.component';
import { ExpandCard } from '../../assets/icons';
import { getLastWeekdayDate, isRegion, months } from '../../utils/helpers.utils';
import { ITaxStat } from '../../interfaces/snp.interface';
import { useParams } from 'react-router-dom';

interface IProps {
  handleFullScreen: (obj: any) => void,
  data: ITaxStat[]
}

const tabs = ['REGIONAL_BUDGET', 'PROPER_REGIONAL_BUDGET']

const TaxComponent: FC<IProps> = ({ handleFullScreen, data }) => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext)
  const { kato } = useParams();
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const findData = (tab: string): ITaxStat => {
    return data.find((item: any) => item.type === tab) || {} as ITaxStat
  }

  return (
    <BasicStatsItem theme={theme} id="tax">
      <div className="title">
        <div className="left">
          <Text color='var(--primary-color)' fontWeight={500} fontSize='0.875rem'>{t(`district-income.oblast`)}</Text>
          <Text color='#818689' fontWeight={400} fontSize='0.75rem'>{getLastWeekdayDate(true)}, {kato && isRegion(+kato) ? 'млн. ' : 'тыс. '}{t('form.tenge')}</Text>
        </div>
        <div className="right">
          <span className='unit-container' >
            <ExpandCard onClick={() => handleFullScreen && handleFullScreen({ isOpen: true, type: 'DistrictIncome' })} />
          </span>
        </div>
      </div>

      <div className="body">
        <div className="tabs">
          {tabs.map((tab) => <Text
            onClick={() => setSelectedTab(tab)}
            fontSize='0.5rem'
            fontWeight={selectedTab === tab ? 700 : 400}
            color={`${selectedTab === tab ? 'var(--text-color)' : 'var(--gray)'}`}
            className={`${selectedTab === tab && 'selected'}`}
          >
            {t('taxStats.' + tab)}
          </Text>)}
        </div>
        <div className="tax-grid">
          {/* ROW 1 */}
          <Text className='header' fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>{t('taxStats.income')}</Text>
          <Text className='header' fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>{t('taxStats.table-plan')}</Text>
          <Text className='header' fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>{t('taxStats.table-fact')}</Text>
          <div className='merged header'>
            <Text fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>
              Исполнение
            </Text>
            <Text className="lower">
              <Text fontWeight={400} color="var(--text-color)" fontSize='0.5625rem'>{t('taxStats.table-period')}</Text>
              <Text fontWeight={400} color="var(--text-color)" fontSize='0.5625rem'>{t('taxStats.table-annual')}</Text>
            </Text>
          </div>

          {/* ROW 2 */}
          <Text fontWeight={700} color="var(--text-color)" fontSize='0.75rem' style={{ minWidth: "100%" }}>{t('taxStats.total')} </Text>
          {(['annual', 'fact', 'planPercent', 'annualPercent'] as (keyof ITaxStat)[]).map((item: any) => <div className="wrap">
            <Text className='wrap__item' fontWeight={700} color="var(--primary-color)" fontSize='0.75rem'>{findData(selectedTab)?.[item as keyof ITaxStat] || 0}{item.includes('Percent') && '%'}</Text>
          </div>)}

          {/* ROW 3 */}
          <Text fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>{t('taxStats.tax')}</Text>
          {(['taxRevenuesAnnual', 'taxRevenuesFact', 'taxRevenuesPlanPercent', 'taxRevenuesAnnualPercent'] as (keyof ITaxStat)[]).map((item: any) => <div className="wrap">
            <Text className='wrap__item' fontWeight={400} color="var(--primary-color)" fontSize='0.75rem'>{findData(selectedTab)?.[item as keyof ITaxStat] || 0}{item.includes('Percent') && '%'}</Text>
          </div>)}

          {/* ROW 4 */}
          <Text fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>{t('taxStats.nonTax')}</Text>
          {(['nonTaxRevenuesAnnual', 'nonTaxRevenuesFact', 'nonTaxRevenuesPlanPercent', 'nonTaxRevenuesAnnualPercent'] as (keyof ITaxStat)[]).map((item: any) => <div className="wrap">
            <Text className='wrap__item' fontWeight={400} color="var(--primary-color)" fontSize='0.75rem'>{findData(selectedTab)?.[item as keyof ITaxStat] || 0}{item.includes('Percent') && '%'}</Text>
          </div>)}

          {/* ROW 5 */}
          <Text fontWeight={400} color="var(--text-color)" fontSize='0.75rem'>{t('taxStats.fixedAssets')}</Text>
          {(['fixedAssetsSaleAnnual', 'fixedAssetsSaleFact', 'fixedAssetsSalePlanPercent', 'fixedAssetsSaleAnnualPercent'] as (keyof ITaxStat)[]).map((item: any) => <div className="wrap">
            <Text className='wrap__item' fontWeight={400} color="var(--primary-color)" fontSize='0.75rem'>{findData(selectedTab)?.[item as keyof ITaxStat] || 0}{item.includes('Percent') && '%'}</Text>
          </div>)}

        </div>
      </div>
    </BasicStatsItem>
  )
}

export default TaxComponent